module.exports = __webpack_public_path__ + "static/media/rotor-solution-front.d6fc5354.svg";